import { AppState } from "@Store/index";
import { useEffect } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import {fetchPlusCategoriesDataIfNeeded} from "../data/plusCategoriesPageReducer";
import { RouteComponentProps } from "react-router";

const useAmberPlusCategories = (props: RouteComponentProps) => {
  const dispatch = useDispatch();
  const { isError, isStatus500 } = useSelector(
    ({ amberPlusPageData }: AppState) => ({
      isError: amberPlusPageData.readyStatus === "failure",
      isStatus500: !JSON.stringify(amberPlusPageData.error)?.includes("404"),
    }),
    shallowEqual,
  );

  useEffect(() => {
    dispatch(fetchPlusCategoriesDataIfNeeded(props));
  }, [dispatch]);

  return {
    isError,
    isStatus500,
  };
};

export default useAmberPlusCategories;
